import Swiper from 'swiper/bundle';
/**
 * Validate current slide
 */

function clearCF7Error($el) {
    const $wrap = $el.closest('.wpcf7-form-control-wrap');
    $el.removeClass('wpcf7-not-valid');
    $wrap.find('.wpcf7-not-valid-tip').remove();
}

function showCF7Error($el, message) {
    const $wrap = $el.closest('.wpcf7-form-control-wrap');

    clearCF7Error($el);

    const $error = $('<span/>', {
        class: 'wpcf7-not-valid-tip',
        text: message
    });

    $el.addClass('wpcf7-not-valid').after($error);
}

function escapeHtml(value) {
    if (typeof value !== 'string') {
        return value;
    }

    return value
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
}

function setSelectPrefill($field, fieldValue) {
    const valueToSet = String(fieldValue).trim();
    const select = $field.get(0);

    if (!select) {
        return;
    }

    // Reset previous selection
    Array.from(select.options).forEach((option) => {
        option.selected = false;
    });

    // Set matching option manually
    const matchedOption = Array.from(select.options).find((option) => {
        return String(option.value).trim() === valueToSet;
    });

    if (matchedOption) {
        matchedOption.selected = true;
        select.value = matchedOption.value;
    } else {
        select.value = valueToSet;
    }

    $field.trigger('input').trigger('change');
}

function applyPopupPrefill($popupForm) {
    const rawPrefill = $popupForm.attr('data-prefill-fields');

    if (!rawPrefill) {
        return;
    }

    let prefillFields = {};

    try {
        prefillFields = JSON.parse(rawPrefill);
    } catch (error) {
        console.error('Invalid prefill fields JSON:', error);
        return;
    }

    const $form = $popupForm.find('form');

    if (!$form.length) {
        return;
    }

    Object.entries(prefillFields).forEach(([fieldName, fieldValue]) => {
        const safeName = window.CSS && CSS.escape ? CSS.escape(fieldName) : fieldName;
        const $fields = $form.find(`[name="${safeName}"], [name="${safeName}[]"]`);

        if (!$fields.length) {
            return;
        }

        $fields.each(function () {
            const $field = $(this);

            if ($field.is('select')) {
                setSelectPrefill($field, fieldValue);

                // Re-apply after other scripts finish initialization
                requestAnimationFrame(() => {
                    setSelectPrefill($field, fieldValue);
                });

                setTimeout(() => {
                    setSelectPrefill($field, fieldValue);
                }, 100);

                return;
            }

            if ($field.is('textarea') || $field.is('input[type="text"], input[type="email"], input[type="tel"], input[type="hidden"], input:not([type])')) {
                $field.val(fieldValue).trigger('input').trigger('change');
            }
        });
    });
}

const isCurrentSlideValid = (currentSlide) => {

    const $requiredWraps = $(currentSlide)
        .find('span.wpcf7-form-control-wrap')
        .filter(function () {
            const $control = $(this).find('.wpcf7-form-control');
            return $control.hasClass('wpcf7-validates-as-required');
        });

    if (!$requiredWraps.length) return true;

    let valid = true;

    $requiredWraps.each(function () {
        const $control = $(this).find('.wpcf7-form-control');

        if ($control.is('input:not([type="radio"]):not([type="checkbox"]), textarea, select')) {
            const val = ($control.val() || '').trim();

            if (!val) {
                valid = false;
                return false;
            }

            // minlength / maxlength (for all inputs, including tel)
            const min = parseInt($control.attr('minlength') || '0', 10);
            const max = parseInt($control.attr('maxlength') || '0', 10);

            if (min && val.length < min) {
                valid = false;
                return false;
            }

            if (max && val.length > max) {
                valid = false;
                return false;
            }

            // optional: for tel, allow only + and digits (no pattern needed)
            if ($control.attr('type') === 'tel') {
                const cleaned = val.replace(/\s+/g, '');
                if (!/^\+?\d+$/.test(cleaned)) {
                    valid = false;
                    return false;
                }
            }
        }

        if ($control.hasClass('wpcf7-radio') || $control.hasClass('wpcf7-checkbox')) {
            if (!$control.find('input:checked').length) {
                valid = false;
                return false;
            }
        }
    });

    return valid;
};

/**
 * Show all validation errors on the slide
 */
const showErrors = (currentSlide) => {

    $(currentSlide)
        .find('.wpcf7-validates-as-required')
        .each(function () {

            const $el = $(this);

            if ($el.is('input, textarea, select')) {
                const val = ($el.val() || '').trim();

                const min = parseInt($el.attr('minlength') || '0', 10);
                const max = parseInt($el.attr('maxlength') || '0', 10);

                let bad = false;

                if (!val) bad = true;
                if (!bad && min && val.length < min) bad = true;
                if (!bad && max && val.length > max) bad = true;

                if (!bad && $el.attr('type') === 'tel') {
                    const cleaned = val.replace(/\s+/g, '');
                    if (!/^\+?\d+$/.test(cleaned)) bad = true;
                }

                if (bad) showCF7Error($el);
            }

            if ($el.hasClass('wpcf7-radio') || $el.hasClass('wpcf7-checkbox')) {
                if (!$el.find('input:checked').length) {
                    showCF7Error($el);
                }
            }
        });

    $(currentSlide)
        .find('.wpcf7-not-valid')
        .first()
        .trigger('focus');
};

/**
 * Initialize Swiper
 */
const buildSwiperSlider = (sliderElm) => {

    const sliderIdentifier = sliderElm.dataset.id;
    const $form = $(sliderElm).closest('form');
    const $popup = $form.closest('.popup-form');
    const scrollbarWrap = $popup.find('.wrap-swiper-scrollbar')[0];

    /**
     * Toggle scrollbar visibility
     */
    const updateScrollbarVisibility = (swiper) => {
        if (!scrollbarWrap || !swiper.scrollbar) return;

        if (swiper.activeIndex === 0) {
            scrollbarWrap.style.display = 'none';
        } else {
            scrollbarWrap.style.display = 'block';
            swiper.scrollbar.updateSize();
            swiper.update();
        }
    };

    // --- jQuery Validate init (once per form)
    if ($.fn.validate && !$form.data('has-jq-validate')) {
        // Custom rule for international phone (E.164-ish)
        if ($.validator && !$.validator.methods.e164phone) {
            $.validator.addMethod('e164phone', function (value, element) {
                const v = String(value || '').trim().replace(/\s+/g, '');
                if (this.optional(element)) return true;
                // + and 8-15 digits (E.164 digits length), first digit after + cannot be 0
                return /^\+[1-9]\d{7,14}$/.test(v);
            }, 'Введіть номер у міжнародному форматі, напр. +380501234567');
        }

        $form.validate({
            ignore: [], // IMPORTANT: validate hidden too (we will restrict manually by slide)
            // Put error exactly like CF7
            errorPlacement: function (error, element) {
                showCF7Error($(element), error.text());
            },
            success: function (label, element) {
                clearCF7Error($(element));
            },
            highlight: function (element) {
                $(element).addClass('wpcf7-not-valid');
            },
            unhighlight: function (element) {
                clearCF7Error($(element));
            }
        });

        // Attach e164phone rule to tel[name="phone"] (and any other tel if you want)
        $form.find('input[type="tel"]').each(function () {
            const $tel = $(this);
            $tel.rules('add', { e164phone: true });
        });

        $form.data('has-jq-validate', true);
    }

// Validate only fields in current slide
    function validateCurrentSlide(swiperInstance) {
        if (!$.fn.validate) return true;

        const v = $form.data('validator') || $form.validate();
        const currentSlide = swiperInstance.slides[swiperInstance.previousIndex];
        const $fields = $(currentSlide)
            .find('input, textarea, select')
            .filter(':visible')
            .filter(function () { return !this.disabled; });

        // Clear previous errors within the slide first (optional, but feels nicer)
        $fields.each(function () { clearCF7Error($(this)); });

        let ok = true;

        $fields.each(function () {
            // Only validate required fields OR fields that have value (so format rules apply)
            const $el = $(this);
            const isRequired = $el.hasClass('wpcf7-validates-as-required') || $el.prop('required');
            const hasValue = String($el.val() || '').trim() !== '';

            if (!isRequired && !hasValue) return;

            if (!v.element(this)) {
                ok = false;
            }
        });

        if (!ok) {
            // focus first invalid
            $(currentSlide).find('.wpcf7-not-valid').first().trigger('focus');
        }

        return ok;
    }

    const swiper = new Swiper(`#${sliderElm.id}`, {
        slidesPerView: 1,
        loop: false,
        updateOnWindowResize: true,
        navigation: {
            nextEl: `.swiper-button-next-${sliderIdentifier}`,
            prevEl: `.swiper-button-prev-${sliderIdentifier}`,
        },
        scrollbar: {
            el: '.popup-form .swiper-scrollbar',
        },
        on: {
            init() {
                updateScrollbarVisibility(this);
            },
            /**
             * Prevent slide change if validation fails
             */
            slideNextTransitionStart() {
                if ($.fn.validate) {
                    if (!validateCurrentSlide(this)) {
                        this.slideTo(this.previousIndex, 0, false);
                        return;
                    }
                } else {
                    // fallback: твоя проста required-логіка (можеш лишити або прибрати)
                    const currentSlide = this.slides[this.previousIndex];
                    if (!isCurrentSlideValid(currentSlide)) {
                        this.slideTo(this.previousIndex, 0, false);
                        showErrors(currentSlide);
                        return;
                    }
                }
            },

            /**
             * "Next" / "Submit" buttons toggle
             */
            slideChange() {

                updateScrollbarVisibility(this);

                const isLast = this.isEnd;
                $form.find('.ms-next-step').toggle(!isLast);
                $form.find('.wrap-submit').toggle(isLast);
                $form.find('.ms-submit-step').toggle(isLast);
            }
        }
    });

    /**
     * Clear errors on input/change
     */
    $form.on('input change', '.wpcf7-form-control', function () {
        clearCF7Error($(this));
    });

    return swiper;
};


/**
 * Initialize all multi-step forms
 */
$('.slider-form.swiper').each((_, element) => {
    buildSwiperSlider(element);
});

jQuery(function ($) {

    $(document).on('wpcf7submit', '.popup-form form.wpcf7-form', function (e) {
        const status = e.originalEvent.detail.status;
        console.log('STATUS:', status);

        if (status !== 'mail_sent') {
            return;
        }

        // hide form
        const $popupContent = $(this).closest('.wrap-popup-content');
        $popupContent.hide();

        // show success block
        $popupContent.siblings('.success-block').show();
    });

    $('.popup-form').each(function () {
        applyPopupPrefill($(this));
    });

    $(document).on('shown.bs.modal', '.modal', function () {
        const $popupForm = $(this).find('.popup-form');

        if (!$popupForm.length) {
            return;
        }

        applyPopupPrefill($popupForm);
    });

    $(document).on('change', '.popup-form input[type="file"]', function () {
        const $input = $(this);
        const $wrap = $input.closest('.wpcf7-form-control-wrap');
        const $name = $wrap.find('.file-upload-name');

        if (this.files && this.files.length) {
            $name.text(this.files[0].name);
        } else {
            $name.text('Файл не вибрано');
        }
    });
});
